import $ from 'jquery';
import setHeight from '../../scripts/util/dom/setHeight';

export default class Toggle {
	constructor() {
		this.selectors = {
			el: '.js-toggle',
			accord: '.js-accordeon',
			wrapper: '.js-toggle-wrapper',
			content: '.js-toggle-content',
			scroll: '.js-toggle-scroll',
			hint: '.js-hint',
			page: {
				history: '.js-history-page'
			}
		};

		this.classes = {
			active: 'toggle_state_active',
			disable: 'toggle_state_disable',
			noscroll: 'noscroll'
		};

		this.$accord = $(this.selectors.accord);
		this.$wrapper = $(this.selectors.wrapper);
		this.$el = $(this.selectors.el);
		this.$window = $(window);
		this.$hint = $(this.selectors.hint);
	}

	toggle = e => {
		const $target = $(e.currentTarget);
		const $wrapper = $target.next(this.selectors.wrapper);
		const $content = $wrapper.children();
		const $parent = $target.closest(this.selectors.accord);
		const $toggleActive = $parent.find(`.${this.classes.active}`);
		const $wrapperActive = $toggleActive.next(this.selectors.wrapper);
		const $scroll = $target.closest(this.selectors.scroll);
		const isHistoryPage = $target.closest(this.selectors.page.history).length;

		if ($target.hasClass(this.classes.active)) {
			return;
		}
		$toggleActive.removeClass(this.classes.active);
		$wrapperActive.css({
			height: 0,
			overflow: 'hidden'
		});
		$target.addClass(this.classes.active);
		setHeight($wrapper, $content);
		if (isHistoryPage) {
			setTimeout(() => $wrapper.css('overflow', 'visible'), 201);
		}
		if ($scroll.length) {
			setTimeout(() => this.scrollTo($scroll), 250);
		}
	};

	scrollTo = $el => {
		const $body = $('html, body');
		const top = $el.offset().top;
		$body.animate({
			scrollTop: top
		}, 400);
	};

	setHeight = () => {
		const $active = $(`.${this.classes.active}`);
		if ($active.length) {
			$active.each((i, element) => {
				const $el = $(element);
				const $wrapper = $el.next(this.selectors.wrapper);
				const $content = $wrapper.children();
				setHeight($wrapper, $content);
			});
		}
	};

	render = () => {
		if (this.$accord.length) {
			this.$el.on('click', this.toggle);
			this.$window.on('resize', this.setHeight);
			this.$window.on('load', this.setHeight);
			this.$hint.hover(
				() => this.$el.addClass(this.classes.disable),
				() => this.$el.removeClass(this.classes.disable)
			);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/toggle/index.js
 **/